import React, { useEffect, useMemo } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import InstructionTitle from '../Instructions/InstructionTitle';
import InstructionContent from '../Instructions/InstructionContent';
import { Button, Divider } from 'antd';
import * as actions from '../../store/actions';
import { fetchAssessment } from '../../store/actions/AssessmentActions';
import { updateQuestionDetails } from '../../Utils/questionDetailsUpdater';
import { DEFAULT_RESPONSE_DETAILS, SECTION_STATUS_IN_PROGRESS } from '../../const';
import { setProgress, setQuestionDetails } from '../../store/actions';
import styles from './SectionModal.scss';

const responseDetails = {
  id: '',
  visited: false,
  answered: false,
  markedForReview: false,
  answer: [],
};

const SectionsModal = () => {
  const { section_id, assessment_id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const sections = useSelector(state => state.assessment.sections);
  const { mcqsResponses, progress } = useSelector(state => state.assessment);

  const section = useMemo(() => sections.find(s => s.id === section_id), [sections, section_id]);
  useEffect(() => {
    const handlePopstate = e => {
      window.history.go(1);
    };
    if (!window.popstateListenerAdded) {
      window.addEventListener('popstate', handlePopstate);
      window.popstateListenerAdded = true;
    }
    if (!sessionStorage.getItem('assessment_id')) {
      sessionStorage.setItem('assessment_id', assessment_id);
    }
  }, []);

  useEffect(() => {
    if (sections.length === 0 || (section && sections[0].id === section.id)) {
      dispatch(fetchAssessment(assessment_id));
    }
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      actions.updateSectionStatusLocal({
        sectionId: section_id,
        status: SECTION_STATUS_IN_PROGRESS,
      }),
    );
  }, [section_id, dispatch]);

  if (!section) {
    return <div></div>;
  }

  const goToSectionOnClick = () => {
    // Set the current section ID before navigating
    dispatch(actions.setCurrentSectionId(section.id));

    if (section.type === 'mcqs') {
      // Update question details using the utility function
      const currentMcqIds = section.mcqs.map(mcqId => ({ id: mcqId }));
      const newQuestionDetails = updateQuestionDetails(
        currentMcqIds,
        mcqsResponses,
        DEFAULT_RESPONSE_DETAILS,
      );

      // Dispatch the actions
      dispatch(setQuestionDetails(newQuestionDetails));
      dispatch(setProgress({ ...progress, total: currentMcqIds.length }));
      dispatch(actions.getRecoredResponses(assessment_id));

      history.push(`/assessment/${assessment_id}/mcqs/${section.mcqs[0]}`);
    } else {
      history.push(`/assessment/${assessment_id}/problem/${section.problems[0]}`);
    }
  };

  const totalQuestion = {
    mcqs: section.mcqs?.length || 0,
    problems: section.problems?.length || 0,
  };
  const sectionTimer = section.total_time;

  return (
    <div className={styles['sectionModal-wrapper']}>
      <div className={styles['sectionModal-container']}>
        <InstructionTitle
          totalQuestion={totalQuestion}
          timer={sectionTimer}
          title={section.title}
        />
        <InstructionContent content={section.instructions} />
        <Divider className={styles['sectionModal-divider']} />
        <Button
          className={styles['section-btn']}
          type="primary"
          onClick={goToSectionOnClick}
        >
          Go to section
        </Button>
      </div>
    </div>
  );
};

export default SectionsModal;
